if (!customElements.get("sticky-add-to-cart")) {
  class StickyAddToCart extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.section = document.getElementById(`shopify-section-${this.sectionId}`);
      if (!this.section) return;

      this.productForm = this.section.querySelector(`product-form[data-section-id="${this.sectionId}"]`);
      this.variantPicker = this.section.querySelector(`variant-picker[data-section="${this.sectionId}"]`);
      if (!this.productForm) return;

      this.mobileQuery = window.matchMedia("(max-width: 767px)");
      this.handleScroll = () => {
        if (this.ticking) return;
        this.ticking = true;
        requestAnimationFrame(() => {
          const formRect = this.productForm.getBoundingClientRect();
          const formIsVisible = formRect.top < window.innerHeight && formRect.bottom > 0;
          this.classList.toggle("sticky-atc--active", window.scrollY > 96 && !formIsVisible);
          this.ticking = false;
        });
      };
      this.configureMode = () => {
        this.observer?.disconnect();
        window.removeEventListener("scroll", this.handleScroll);
        this.classList.remove("sticky-atc--active");

        if (this.mobileQuery.matches) {
          window.addEventListener("scroll", this.handleScroll, { passive: true });
          this.handleScroll();
          return;
        }

        let lastY = 0;
        this.observer = new IntersectionObserver(([entry]) => {
          const currentY = entry.boundingClientRect.y;
          const scrollingDown = currentY < lastY;
          lastY = currentY;
          this.classList.toggle("sticky-atc--active", !entry.isIntersecting && scrollingDown);
        });
        this.observer.observe(this.productForm);
      };

      this.mobileQuery.addEventListener("change", this.configureMode);
      this.configureMode();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      window.removeEventListener("scroll", this.handleScroll);
      this.mobileQuery?.removeEventListener("change", this.configureMode);
    }
  }

  customElements.define("sticky-add-to-cart", StickyAddToCart);
}